import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { CareTEamService } from 'src/app/services/care-team.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router } from '@angular/router';
import { ConsentFinancialSettings } from 'src/app/models/consentfinancial/consentfinancial';
import { PDFProgressData } from 'ng2-pdf-viewer';
//import { SignaturePad } from 'angular2-signaturepad';
import { TranslateService } from '@ngx-translate/core';
import SignaturePad from 'signature_pad';
declare var $: any;

@Component({
  selector: 'app-consentform',
  templateUrl: './consentform.component.html',
  styleUrls: ['./consentform.component.css']
})
export class ConsentformComponent {
  @ViewChild('agree') checkboxAgree: ElementRef;
  pageNum: any;
  totalPages: any;
  consentFile: any;
  consentFileUrl: any;
  patientPersonalInfo: PatientPersonalInfo;
  cfsm: ConsentFinancialSettings = new ConsentFinancialSettings();
  pdfPath1 = "";
  zoopLevel: number = 1;
  isDevice = false;
  isRTL: boolean = false;
  constructor(private translateService: TranslateService, private service: CareTEamService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router) {
    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      this.router.navigateByUrl("/");
      return;
    }

    // Navigator.user
    let isAndroid = /(android)/i.test(navigator.userAgent);
    let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isAndroid || isIOS) {
      this.zoopLevel = 0.5;
    }

    this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    this.patientName = this.patientPersonalInfo.LASTNAME + ', ' + this.patientPersonalInfo.FIRSTNAME;
    this.getSettings();
    this.spinner.show();
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.isRTL = false;
        this.phrUtils.setTitle('Formulario de consentimiento');
      } else if (language === 'hi') {
        this.isRTL = false;
        this.phrUtils.setTitle('सहमति पत्र');
      } else if (language === 'ur') {
        this.isRTL = true;
        this.phrUtils.setTitle('رضامندی کا فارم');
      }
      else {
        this.isRTL = false;
        this.phrUtils.setTitle('Consent Form');
      }
    });

  }


  @ViewChild('signatureCanvas') signatureCanvas: ElementRef;
  isEmpty: boolean = true
  signaturePad: SignaturePad;

  ngAfterViewInit() {
    const canvas = this.signatureCanvas.nativeElement;
    this.signaturePad = new SignaturePad(canvas, {
      minWidth: 5,
      //canvasWidth: 500,
      //canvasHeight: 300
    });
  }

  clearSignature() {
    this.signaturePad.clear();
  }
  base64Signature: any;
  drawComplete() {
     this.base64Signature = this.signaturePad.toDataURL();
    // console.log('base64 signature = ');
    // console.log(this.base64Signature);
  }

  drawStart() {
    this.isEmpty = false;
  }


  getSettings() {
    this.service.getConsentFormSettings(this.patientPersonalInfo.PRACTICE_CODE, this.patientPersonalInfo.PATIENT_ACCOUNT)
      .subscribe((res: any) => {
        this.cfsm = res as ConsentFinancialSettings;
        localStorage.setItem("financialCheck", this.phrUtils.encrypt(JSON.stringify(this.cfsm)));
        if (this.cfsm.data && this.cfsm.message == "SUCCESS" && this.cfsm.statusCode == 200) {

          // check and set auth token incase if it is null 7/11/2024 
          try {
            let token = localStorage.getItem("AuthTokenwebServices")
            if (!token || token == '' || token == undefined || token == null || token == 'null') {
              localStorage.setItem("AuthTokenwebServices", this.cfsm.data.acces_Token);
              sessionStorage.setItem("AuthTokenwebServices", this.cfsm.data.acces_Token);
            }
          } catch (error) {
            console.log("in consentform line number 97 " + error);
          }


          this.setInitialandTotalPage();
          let pagesorder = localStorage.getItem('pagesorder');
          this.pageNum = JSON.parse(pagesorder ? pagesorder : '').consent_form;
          this.totalPages = localStorage.getItem('totalPages');
          if ((this.cfsm.data.patient_Consent_Form != "True" && this.cfsm.data.financial_Form != "True") ||
            (this.cfsm.data.iS_PATIENT_CONSENT_AGREE.toLowerCase() == 'true' && this.cfsm.data.iS_PATIENT_FINANCIAL_AGREE.toLowerCase() == 'true')) {
           // this.spinner.hide();
            this.router.navigateByUrl('patient/updateinfo');
          }
          else if (this.cfsm.data.patient_Consent_Form != 'True' || this.cfsm.data.iS_PATIENT_CONSENT_AGREE.toLowerCase() == 'true') {
            this.spinner.hide();
            this.router.navigateByUrl('patient/financial-form');
          }
          if (this.cfsm.data.patient_Consent_Form_Path) {
            this.pdfPath1 = this.getPdfUrl(this.cfsm.data.patient_Consent_Form_Path);
            // this.pdfPath1 = "https://researchtorevenue.files.wordpress.com/2015/04/1r41ai10801601_fong.pdf";
          }
        }
        else {
          this.router.navigateByUrl('patient/updateinfo');
        }
      }, (error: any) => {
        this.spinner.hide();
        //console.log(error.statusText);
      });
  }

  onProgress(progressData: PDFProgressData) {
    if (progressData.loaded === progressData.total) {
      this.spinner.hide();
    }

  }

  loaded(event: any) {
    this.spinner.hide();
  }

  onError(error: any) {
    this.spinner.hide();
    this.phrUtils.showError(error.message);
  }

  getPdfUrl(path: any): string {
    let replaceDoubleSlash = path.replace(/\\\\/g, "\\");
    let orginalServerPath = replaceDoubleSlash.replace(/\\/g, "/");
    let serverName = "assets";
    let serverIp = orginalServerPath.split('/');
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(serverIp[1])) {
      orginalServerPath = orginalServerPath.replace("/" + serverIp[1], serverName);
    }
    else {
      orginalServerPath = serverName + '/' + orginalServerPath;
    }
    return window.location.origin + "/" + orginalServerPath;
  }

  onClear() {
    this.checkboxAgree.nativeElement.checked = false;
    this.patientName = "";
  }


  //   dataURItoBlob(dataURI: string) {    
  //     const byteString = atob(dataURI);
  //     const arrayBuffer = new ArrayBuffer(byteString.length);
  //     const int8Array = new Uint8Array(arrayBuffer);
  //     for (let i = 0; i < byteString.length; i++) {
  //       int8Array[i] = byteString.charCodeAt(i);
  //     }
  //     const blob = new Blob([int8Array], { type: 'image/png' });    
  //     return blob;
  //  }

  patientName: string = "";

  dataURLToBlob(dataURL: any) {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }

  readFileAndSendFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const imgBlob = new Blob([reader.result ? reader.result : ''], {
        type: file.type
      });
      this.spinner.show();
      this.service.SaveSignature(imgBlob, 'api/TalkCheckin/AddSignatureToConsentForm', this.patientPersonalInfo.PATIENT_ACCOUNT.toString(), this.patientPersonalInfo.PRACTICE_CODE.toString(), this.patientPersonalInfo.LASTNAME.toString(), this.patientPersonalInfo.FIRSTNAME.toString(), 'Consent Form')
        .subscribe((res: any) => {
          // {statusCode: 200, message: "success", data: null}
          this.spinner.hide();
          if (res && res.statusCode == 200 && res.message == 'success') {
            $('#SignatureModal').modal('hide');
            this.router.navigateByUrl("patient/financial-form");
          }
          else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showError(text);
            //this.phrUtils.showError("Service is not available, please try later.");
          }
        }, (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        });
    };
    reader.readAsArrayBuffer(file);
  }

  addConsent() {
    this.spinner.show();
    const imgBlob = 'null';
    this.service.SaveSignature(imgBlob, 'api/TalkCheckin/AddSignatureToConsentForm', this.patientPersonalInfo.PATIENT_ACCOUNT.toString(), this.patientPersonalInfo.PRACTICE_CODE.toString(), this.patientPersonalInfo.LASTNAME.toString(), this.patientPersonalInfo.FIRSTNAME.toString(), 'Consent Form')
      .subscribe((res: any) => {
        // {statusCode: 200, message: "success", data: null}
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == 'success') {
          $('#ConsentModal').modal('hide');
          this.router.navigateByUrl("patient/financial-form");
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          console.log("AddSignatureToConsentForm failed in consent form");
          $('#ConsentModal').modal('hide');
          this.router.navigateByUrl("patient/financial-form");
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        console.log("AddSignatureToConsentForm failed in consent form");
        $('#ConsentModal').modal('hide');
        this.router.navigateByUrl("patient/financial-form");
        //this.phrUtils.showError("Service is not available, please try later.");
      });
  }

  applySIgnature() {
    if (this.signaturePad.isEmpty()) {
      let text = "Please draw your signature.";
      this.translateService.get('Alerts.consentForm_draw_signature').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
      //this.phrUtils.showInfo("Please draw your signature.");
      return;
    }
    const dataUrl = this.signaturePad.toDataURL();
    const blob = this.dataURLToBlob(dataUrl);
    this.readFileAndSendFile(blob);
  }

  agreeToTerms(e: any) {
    if (e.target.checked) {
      this.patientName = this.patientPersonalInfo.LASTNAME + ', ' + this.patientPersonalInfo.FIRSTNAME;
    }
    else {
      this.patientName = "";
    }
  }

  onIAgreeClick() {
   // $('#SignatureModal').modal('show');
    $('#ConsentModal').modal('show');
  }

  dissAgreedClicked() {
    let query = sessionStorage.getItem('AccessLink');
    // localStorage.setItem("backToConsent", "1");
    if (query == null) {
      query = '';
    }
    this.router.navigateByUrl("patient/verifypatient?pa=" + query);
  }
  setInitialandTotalPage() {
    let initialpage = 0;
    let pagesorder = {
      'consent_form': '',
      'financial_form': '',
      'update_info': '',
      'careteam': '',
      'insurance': '',
      'symptoms_checker': '',
      'intake': '',
      'covid_form': '',
    };
    let totalPage = 3;
    if (this.cfsm.data.patient_Consent_Form.toLowerCase() == 'true' && this.cfsm.data.iS_PATIENT_CONSENT_AGREE.toLowerCase() == 'false') {
      totalPage++;
      initialpage++;
      pagesorder.consent_form = initialpage.toString();
    }
    else {
      pagesorder.consent_form = '0';
    }
    if (this.cfsm.data.financial_Form.toLowerCase() == 'true' && this.cfsm.data.iS_PATIENT_FINANCIAL_AGREE.toLowerCase() == 'false') {
      totalPage++;
      initialpage++;
      pagesorder.financial_form = initialpage.toString();
    }
    initialpage++;
    pagesorder.update_info = initialpage.toString();
    initialpage++;
    pagesorder.careteam = initialpage.toString();
    initialpage++;
    pagesorder.insurance = initialpage.toString();
    if (this.cfsm.data.enable_Symston_Checker.toLowerCase() == 'true') {
      totalPage++;
      initialpage++;
      pagesorder.symptoms_checker = initialpage.toString();
    }
    // commect intake code because the intake form is setting base and there APi's are in the intake form when reached on intake form then this pages number updated
    // if(this.cfsm.data.enable_Intake_form.toLowerCase()=='true')
    // {
    //   totalPage++;
    //   initialpage++;
    //   pagesorder.intake = initialpage.toString();
    // }
    if (this.cfsm.data.enable_COVID19_Questionnaire.toLowerCase() == 'true') {
      totalPage++;
      initialpage++;
      pagesorder.covid_form = initialpage.toString();
    }
    localStorage.setItem('totalPages', totalPage.toString());
    localStorage.setItem('pagesorder', JSON.stringify(pagesorder));
    //check if the user login again from the lockscreen then check the last visited URL and then redirects to the last visited URL
    if (localStorage.getItem("lockscreen") && localStorage.getItem("lockscreen") == "true") {
      localStorage.setItem("lockscreen", "false");
      let visitURL = sessionStorage.getItem("VisitedURL");
      this.router.navigateByUrl(visitURL ? visitURL : '/');
    }
  }
}
